<template>
  <div class = "planSelectionContainer">
    <div v-if="step < 1">
      <p class="centerAlign register--title mb-5 mt-5">
        Select your plan
      </p>
        <div class = "showPlanContainer"
        >
            <ul class="segmented-control">
            <li class="segmented-control__item">
                <input
                class="segmented-control__input"
                v-model="growth"
                type="radio"
                name="option"
                id="option-1"
                v-bind:value="'1'"
                checked
                />
                <label
                class="centerAlign segmented-control__label"
                for="option-1"
                >Growth</label
                >
            </li>
            <li class="segmented-control__item">
                <input
                class="segmented-control__input"
                v-model="growth"
                type="radio"
                name="option"
                id="option-2"
                v-bind:value="'2'"
                />
                <label
                class="centerAlign segmented-control__label"
                for="option-2"
                >Income</label
                >
            </li>
            </ul>
        </div>
      <div>
        <div v-if="showGrowthPlan">
            <div class = "showPlanContainer"
            >
            <div style = "height: 415px; max-width: 300px !important; padding: 25px" class="white-box payment-methods__content">
                <div v-if = "!showGrowthCons" class="ribbon ribbon-top-right">
                    <span>Selected</span>
                </div>
                <div>
                <div class = "pb-5">
                    <span
                    style="color: #9e9e9e; font-weight: 500;"
                    class="font-size-md"
                    >Earn upto</span>
                    <img class = "pl-5" src="/img/crown-icon.svg" alt="Recommended"
                    />
                </div>
                <div>
                    <span style="font-size: 36px; color: #232323; font-weight: 700"
                    >14%</span
                    >
                    <span
                    style="color: #232323; font-weight: 400; padding-left: 1px"
                    class="font-size-base pb-5"
                    >per annum</span
                    >
                </div>
                <div class = "pb-8">
                    <span style="font-size: 18px; color: #002fa7; font-weight: 800"
                    >Conservative</span
                    >
                </div>
                <div
                    style="padding-bottom: 8px; display: table-cell"
                    class="payment-methods__pay-info"
                >
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Invest ₹5000 to ₹50 Lakh</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Investment Lock-in - 12 months</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Your funds are invested in loans with
                        <strong class = "ratingText">High</strong> credit
                        ratings.</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Interest is earned monthly and reinvested to compound returns.</span
                    >
                    </div>
                </div>
                <div
                    class="showPlanContent register__form--referral-bottom"
                >
                    <button
                    v-if = "showGrowthCons"
                    @click="growthConservative"
                    class="selectPlanButton btn_new btn-secondary-plan mb-5 forhove"
                    >
                    Choose Plan
                    </button>
                    <button
                    v-if = "!showGrowthCons"
                    @click="continueWithPlan"
                    class="btn_continue btn_new btn-secondary-new mb-5 forhove"
                    >
                    Continue
                    </button>
                </div>
                </div>
            </div>
            <div style = "height: 415px; max-width: 300px !important; padding: 25px" class="white-box payment-methods__content">
                <div v-if = "!showGrowthAgg" class="ribbon ribbon-top-right">
                    <span>Selected</span>
                </div>
                <div>
                <div class="pb-5">
                    <span
                    style="color: #9e9e9e; font-weight: 500"
                    class="font-size-md"
                    >Earn upto</span
                    >
                </div>
                <div>
                    <span style="font-size: 36px; color: #232323; font-weight: 700"
                    >18%</span
                    >
                    <span
                    style="color: #232323; font-weight: 400; padding-left: 1px"
                    class="font-size-base pb-5"
                    >per annum</span
                    >
                </div>
                <div class = "pb-8">
                    <span style="font-size: 18px; color: #002fa7; font-weight: 800"
                    >Aggressive</span
                    >
                </div>
                <div
                    style="padding-bottom: 8px; display: table-cell"
                    class="payment-methods__pay-info"
                >
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Invest ₹5000 to ₹50 Lakh</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Investment Lock-in - 12 months</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Your funds are invested in loans with
                        <strong class = "ratingText">Medium</strong> credit
                        ratings.</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Interest is earned monthly and reinvested to compound returns.</span
                    >
                    </div>
                </div>
                <div
                    class="showPlanContent register__form--referral-bottom"
                >
                    <button
                    v-if = "showGrowthAgg"
                    @click="growthAggressive"
                    class="selectPlanButton btn_new btn-secondary-plan mb-5 forhove"
                    >
                    Choose Plan
                    </button>
                    <button
                    v-if = "!showGrowthAgg"
                    @click="continueWithPlan"
                    class="btn_continue btn_new btn-secondary-new mb-5 forhove"
                    >
                    Continue
                    </button>
                </div>
                </div>
            </div>
            </div>
            <p class = "disclaimer rightAlign"><a target="_blank" rel="noreferrer noopener" href="https://www.indiap2p.com/invest/growth-plan">Click here</a> for product details & risks</p>
        </div>
        <div v-if="!showGrowthPlan">
            <div class = "showPlanContainer"
            >
            <div style = "height: 415px; max-width: 300px !important; padding: 25px" class="white-box payment-methods__content">
                <div v-if = "!showIncomeCons" class="ribbon ribbon-top-right">
                    <span>Selected</span>
                </div>
                <div>
                <div class="pb-5">
                    <span
                    style="color: #9e9e9e; font-weight: 500"
                    class="font-size-md"
                    >Earn upto</span
                    >
                </div>
                <div>
                    <span style="font-size: 36px; color: #232323; font-weight: 700"
                    >12%</span
                    >
                    <span
                    style="color: #232323; font-weight: 400; padding-left: 1px"
                    class="font-size-base pb-5"
                    >per annum</span
                    >
                </div>
                <div class = "pb-8">
                    <span style="font-size: 18px; color: #002fa7; font-weight: 800"
                    >Conservative</span
                    >
                </div>
                <div
                    style="padding-bottom: 8px; display: table-cell"
                    class="payment-methods__pay-info"
                >
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Invest ₹5000 to ₹50 Lakh</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Investment Lock-in - 12 months</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Your funds are invested in loans with
                        <strong class = "ratingText">High</strong> credit
                        ratings.</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >*Interest earnings are paid out monthly.</span
                    >
                    </div>
                </div>
                <div
                    class="showPlanContent register__form--referral-bottom"
                >
                    <button
                    v-if = "showIncomeCons"
                    @click = "incomeConservative"
                    class="selectPlanButton btn_new btn-secondary-plan mb-5 forhove"
                    >
                    Choose Plan
                    </button>
                    <button
                    v-if = "!showIncomeCons"
                    @click="continueWithPlan"
                    class="btn_continue btn_new btn-secondary-new mb-5 forhove"
                    >
                    Continue
                    </button>
                </div>
                </div>
            </div>
            <div style = "height: 415px; max-width: 300px !important; padding: 25px" class="white-box payment-methods__content">
                <div v-if = "!showIncomeAgg" class="ribbon ribbon-top-right">
                    <span>Selected</span>
                </div>
                <div>
                <div class="pb-5">
                    <span
                    style="color: #9e9e9e; font-weight: 500"
                    class="font-size-md"
                    >Earn upto</span
                    >
                </div>
                <div>
                    <span style="font-size: 36px; color: #232323; font-weight: 700"
                    >16%</span
                    >
                    <span
                    style="color: #232323; font-weight: 400; padding-left: 1px"
                    class="font-size-base pb-5"
                    >per annum</span
                    >
                </div>
                <div class = "pb-8">
                    <span style="font-size: 18px; color: #002fa7; font-weight: 800"
                    >Aggressive</span
                    >
                </div>
                <div
                    style="padding-bottom: 8px; display: table-cell"
                    class="payment-methods__pay-info"
                >
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Invest ₹5000 to ₹50 Lakh</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Investment Lock-in - 12 months</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >Your funds are invested in loans with
                        <strong class = "ratingText">Medium</strong> credit
                        ratings.</span
                    >
                    </div>
                    <div>
                    <span class = "text-span"
                        ><v-icon
                        class="material-icons-round"
                        >check_circle</v-icon
                        >*Interest earnings are paid out monthly.</span
                    >
                    </div>
                </div>
                <div
                    class="showPlanContent register__form--referral-bottom"
                >
                    <button
                    v-if = "showIncomeAgg"
                    @click = "incomeAggressive"
                    class="selectPlanButton btn_new btn-secondary-plan mb-5 forhove"
                    >
                    Choose Plan
                    </button>
                    <button
                    v-if = "!showIncomeAgg"
                    @click="continueWithPlan"
                    class="btn_continue btn_new btn-secondary-new mb-5 forhove"
                    >
                    Continue
                    </button>
                </div>
                </div>
            </div>
            </div>
        <p class = "disclaimer rightAlign"><a target="_blank" rel="noreferrer noopener" href="https://www.indiap2p.com/invest/income-plan">Click here</a> for product details & risks</p>
                <p class = "disclaimer rightAlign">*First interest pay out may take up to 2 months from the date of investment.</p>
        </div>
      </div>
    </div>
    <v-snackbar v-model="isFailure" app timeout="3000">
      {{ failureText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="isFailure = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import OnboardingService from '@/services/lenderOnboardingService.js'

import LenderService from '@/services/lenderService'

export default {
    name: 'Plan Selection New',
    components: {},
    props: {
        isCreatePortfolio: Boolean,
        currentPortfolio: Object,
        isEditPortfolio: Boolean
    },
    data () {
        return {
            checkPortfolio: null,
            showGrowthCons: true,
            showGrowthAgg: true,
            showIncomeCons: true,
            showIncomeAgg: true,
            showGrowthPlan: true,
            growth: '1',
            planType: null,
            riskType: null,
            portfolio: null,
            amount: null,
            step: 0,
            editPortfolio: false,
            creatingPortfolio: false,
            failureText: 'Something went wrong! Please try again',
            isFailure: false
        }
    },
    watch: {
        growth: function (value) {
            if (value === '1') {
                this.showGrowthPlan = true
            } else {
                this.showGrowthPlan = false
            }
        }
    },
    mounted () {
        if (this.isEditPortfolio) {
            this.editPortfolio = true
            this.amount = this.currentPortfolio.investmentAmount / 100
        }
        if (this.isCreatePortfolio) {
            this.creatingPortfolio = true
        }
        this.checkIfPlanExisting()
    },
    methods: {
        continueWithPlan () {
            this.success()
        },
        checkExistingPortfolio () {
            this.checkPortfolio = this.$store.state.portfolio
            if (this.checkPortfolio.riskProfile === 'conservative' && this.checkPortfolio.planType === 'growth') {
                this.showGrowthCons = false
                this.growth = '1'
            } else if (this.checkPortfolio.riskProfile === 'aggressive' && this.checkPortfolio.planType === 'growth') {
                this.showGrowthAgg = false
                this.growth = '1'
            } else if (this.checkPortfolio.riskProfile === 'aggressive' && this.checkPortfolio.planType === 'income') {
                this.showIncomeAgg = false
                this.growth = '2'
            } else if (this.checkPortfolio.riskProfile === 'conservative' && this.checkPortfolio.planType === 'income') {
                this.showIncomeCons = false
                this.growth = '2'
            }
        },
        checkPortfolioStatus () {
            if (this.editPortfolio) {
                this.portfolio.portfolioId = this.$store.state.portfolio.portfolioId
                this.updatePortfolio()
            } else if (this.creatingPortfolio) {
                this.createPortfolio()
            }
        },
        growthConservative () {
            this.planType = 'growth'
            this.riskType = 'conservative'
            this.portfolio = {
                planType: this.planType,
                riskProfile: this.riskType,
                investmentType: 'autoInvest',
                investmentAmount: 0,
                status: 'created'
            }
            this.checkPortfolioStatus()
        },
        growthAggressive () {
            this.planType = 'growth'
            this.riskType = 'aggressive'
            this.portfolio = {
                planType: this.planType,
                riskProfile: this.riskType,
                investmentType: 'autoInvest',
                investmentAmount: 0,
                status: 'created'
            }
            this.checkPortfolioStatus()
        },
        incomeAggressive () {
            this.planType = 'income'
            this.riskType = 'aggressive'
            this.portfolio = {
                planType: this.planType,
                riskProfile: this.riskType,
                investmentType: 'autoInvest',
                investmentAmount: 0,
                status: 'created'
            }
            this.checkPortfolioStatus()
        },
        incomeConservative () {
            this.planType = 'income'
            this.riskType = 'conservative'
            this.portfolio = {
                planType: this.planType,
                riskProfile: this.riskType,
                investmentType: 'autoInvest',
                investmentAmount: 0,
                status: 'created'
            }
            this.checkPortfolioStatus()
        },
        checkIfPlanExisting () {
            this.$store.commit('isLoading')
            LenderService.checkCreatedPortfolioExists().then((res) => {
                if (res.status === 200) {
                    this.creatingPortfolio = false
                    this.editPortfolio = true
                    const existingPortfolio = {
                        planType: res.data.planType,
                        riskProfile: res.data.riskProfile,
                        investmentType: 'autoInvest',
                        investmentAmount: res.data.investmentAmount,
                        status: res.data.status,
                        portfolioId: res.data._id
                    }
                    this.$store.commit('portfolio/setPortfolio', existingPortfolio)
                    this.$emit('portfolio', existingPortfolio)
                    this.checkExistingPortfolio()

                    if (res.data.pendingInvestmentAmount && res.data.pendingInvestmentAmount > 0) {
                        console.log('pending investment amount exists')
                        this.$emit('skipPayment')
                    }
                } else if (res.status === 404) {
                    this.$store.commit('isNotLoading')
                    this.creatingPortfolio = true
                    this.editPortfolio = false
                }
                this.$store.commit('isNotLoading')
            })
        },
        async createPortfolio () {
            this.$store.commit('isLoading')
            await OnboardingService.createPortfolio(this.portfolio).then((res) => {
                if (res.status === 200) {
                    this.step++
                    this.portfolio.portfolioId = res.data.portfolioId
                    this.portfolio.investmentAmount = this.amount ? this.amount * 100 : 0
                    this.$emit('portfolio', this.portfolio)
                    this.success()
                } else {
                    this.step = 0
                    this.riskType = null
                    this.planType = null
                    this.portfolio = null
                    this.creatingPortfolio = true
                    this.editPortfolio = false
                }
            })
            this.$store.commit('isNotLoading')
        },
        async updatePortfolio () {
            this.$store.commit('isLoading')
            await LenderService.editPortfolio(this.portfolio).then(async (res) => {
                if (res.status === 200) {
                    this.step++
                    this.portfolio.investmentAmount = this.amount * 100
                    this.$emit('portfolio', this.portfolio)
                    this.success()
                } else if (res.status === 409) {
                    this.step = 0
                    this.riskType = null
                    this.planType = null
                    this.portfolio = null
                    this.failureText = 'You have already selected this Plan!'
                    this.isFailure = true
                } else {
                    this.step = 0
                    this.riskType = null
                    this.planType = null
                    this.portfolio = null
                }
            })
            this.$store.commit('isNotLoading')
        },
        success () {
            this.$emit('success', this.portfolio)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";
@import "@/components/dashboard/dashboard.scss";

.selectPlanButton {
}
.disclaimer {
    padding-right: 6px;
    font-size: 12px;
    color: #9e9e9e;
    font-weight: 400
}
.forhove {
  &:hover {
    background: #002fa7 !important;

    color: $white !important;

    h2,
    p,
    span {
      color: $white !important;
    }

    .v-icon.v-icon {
      color: $white !important;
    }
  }
}
.segmented-control {
  display: table;
  width: 300px;
  margin: 2em 0;
  padding: 0;
}

.segmented-control__item {
  display: table-cell;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.segmented-control__input {
  position: absolute;
  visibility: hidden;
}

.segmented-control__label {
  display: block;
  margin: 0 -1px -1px 0; /* -1px margin removes double-thickness borders between items */
  padding: 12px 3px;

  font: 21px sans-serif;
  text-align: center;
  cursor: pointer;
}

.segmented-control__input:checked + .segmented-control__label {
  font-weight: 900;
  color: #042393;
  border-style: solid;
  border-width: 0px 0px 2px 0px;
  border-color: transparent transparent #042393 transparent;
}
.choose-plan__item--paymentType {
  font-size: 16px;
}
.choose-plan__item--text darken {
  font-size: 14px;
}
.bold {
  padding-top: 8px;
  font-size: 18px;
  color: #4f4f4f;
}
.payment-methods {
  display: block;
  .paymentMethodsWrapper {
    display: flex;
    justify-content: space-between;
  }

  &__content {
    border: 1px solid $light-grey;
    padding: 10px;
    position: relative;
    margin: 10px;
    flex-basis: 150px;
    flex-grow: 1;
    h2 {
      font-size: $h4-font-size;
      font-weight: $font-weight-medium;
    }
    .fa-chevron-right {
      position: absolute;
      right: 20px;
      color: $primary;
      top: 50%;
      transform: translateY(-50%);
    }
    .fa-rupee-sign {
      font-size: $font-size-xxs;
      position: relative;
      top: -2px;
      color: $black;
    }
  }

  &__pay-info {
    @include flex(flex, center, flex-start);
      i {
        position: relative;
        top: -1px;
        margin-right: 5px;
        color: $black;
      }
    }
}
.white-box.disabled {
  background-color: rgb(241, 239, 239);
  color: #666e75;
}
.v-application p {
  margin-bottom: 0px;
}
.netTitle {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon img {
    width: 60px;
    height: 60px;
  }

  .transactionMessage {
    padding-bottom: 24px;
    font-size: 24px;
    font-weight: 600;
  }
}
.amount {
  font-size: 18px;
  font-weight: 550 !important;
  letter-spacing: 2px;
}
.register__form {
  min-width: 600px !important;
}
@media (max-width: 375px) {
    .disclaimer {
        width: 300px !important;
        padding-left: 15px
}
}
@media (max-width: 990px) {
  .white-box,
  .px-50 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .paymentMethods .white-box {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
  .showPlanContainer {
        flex-direction: column;
    }

  .dashboard__leftpanel {
    display: none;
  }

  .payment-methods form .paymentMethodsWrapper {
    display: block !important;
  }

  .payment-methods .payment-methods__content {
    border: 1px solid $light-grey;
    padding: 10px;
    margin-top: 12px;
    height: unset;
  }

  .register__form {
    min-width: unset !important;
  }
}
.amountBreakdown {
  display: flex;
  justify-content: space-between;
}
.v-icon.v-icon {
    font-size: 20px;
    color: #4f4f4f;
    height: 15px;
    width: 15px;
}
.showPlanContainer {
    display: flex;
    justify-content: center;
    align-items: center;
}

.showPlanContent {
    display: flex;
    justify-content: center;
    align-items: center;
}

.text-span {
    font-weight: 500;
    font-size: 12px;
    color: #232323
}
.ratingText {
    color: #000000
}
.btn_continue {
    width: 150px !important;
    height: 43px !important
}

.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #002FA7;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 260px;
  padding: 7px 0;
  background-color: #002FA7;
  box-shadow: 0 2px 1px rgba(0,0,0,.1);
  color: #fff;
  font: 500 16px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-align: center;
}

/* top right*/
.ribbon-top-right {
  top: 0px;
  right: 0px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 22px;
}
.ribbon-top-right::after {
  bottom: 22px;
  right: 0;
}
.ribbon-top-right span {
  left: -27px;
  top: 29px;
  transform: rotate(45deg);
}

</style>
